export const PASSWORD_REPEAT_LIMIT = 10;
export const DEFAULT_LOCALE_CODE = 'en-US';